module.exports = __webpack_public_path__ + "static/media/07_plantilla_cuadrada_combo_simple_cf_stills_pet_1.5_cepita_fresh_naranja.1060de8d.png";